import { createSelector } from "reselect";
import { initialState } from "./reducer";

const selectPost = (state) => state.post || initialState;

const selectPostError = createSelector(selectPost, (state) => state.error);
const selectPostData = createSelector(selectPost, (state) => state.postData);

export { selectPostError, selectPostData };